<template>
  <div class="countdown-timer">
    <div style="" :class="$store.state.IS_COMPUTER ? 'time_box_phone' : 'time_box'">
      <img src="../../static/img/cartimg/colck.png" class="icon" alt="" style="width: 20px;height: 20px;margin-right: 5px;">
      课程倒计时：{{ formattedTime }}
    </div>
    <!-- <span @click="startTimer" :disabled="isRunning">启动</span>
    <span @click="pauseTimer" :disabled="!isRunning">暂停</span>
    <span @click="resetTimer">重新计时</span> -->
  </div>
</template>

<script>

export default {
  name: 'CountdownTimer',
  props: {
    // 初始时间（单位：秒），可以通过父组件传入
    initialTime: {
      type: String,
      default: '60', // 默认 3600 秒（1小时）
    },
  },
  watch: {
    initialTime(newval) {
      this.time = Number(newval)
    }
  },
  data() {
    return {
      time: Number(this.initialTime), // 当前剩余时间，单位：秒
      intervalId: null, // 定时器的 ID
      isRunning: false, // 控制倒计时是否在运行
    }
  },
  computed: {
    // 计算并格式化时间为 "hh:mm:ss"
    formattedTime() {
      const hours = String(Math.floor(this.time / 3600)).padStart(2, '0')
      const minutes = String(Math.floor((this.time % 3600) / 60)).padStart(2, '0')
      const seconds = String(this.time % 60).padStart(2, '0')
      return `${hours}:${minutes}:${seconds}`
    },
  },
  mounted() {
  },
  methods: {
    startTimer() {
      if (this.isRunning) return

      this.isRunning = true
      this.intervalId = setInterval(() => {
        if (this.time > 0) {
          this.time--
        } else {
          this.pauseTimer() // 倒计时结束后暂停
          this.$emit('countdown-ended') // 触发倒计时结束事件
        }
      }, 1000)
    },
    pauseTimer() {
      clearInterval(this.intervalId)
      this.isRunning = false
    },
    resetTimer() {
      this.pauseTimer() // 停止计时器
      this.time = Number(this.initialTime) // 重置时间
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId) // 销毁组件时清除定时器
  },
}
</script>

<style scoped lang="less">
.time_box {
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(227, 60, 100);
  border-radius: 60px;
  padding: 5px 10px;
  font-size: 14px;
  line-height: 30px;
}


.time_box_phone {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(227, 60, 100);
  border-radius: 60px;
  padding: 5px 10px;
  font-size: 14px;
  line-height: 18px;
}

// 尺寸小于640px时
@media screen and (max-width: 640px) {
  .time_box_phone {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(227, 60, 100);
    border-radius: 60px;
    padding: 5px 10px;
    font-size: 12px;
    line-height: 18px;

    .icon{
      width: 15px !important;
      height: 15px !important;
    }
  }
}


button {
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/CountdownTimer.vue